// extracted by mini-css-extract-plugin
module.exports = {"content":"item_content__Yatui"};